export default {
  ft: {to_meter: 0.3048},
  'us-ft': {to_meter: 1200 / 3937}
};



//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/constants/units.js
// module id = lG8V
// module chunks = 0